// extracted by mini-css-extract-plugin
module.exports = {"sound-wave":"SoundWave_sound-wave__dybiN"};